import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import type User from 'modules/core/store/models/User'

import type QuestionGroupActor from 'modules/reviews/store/models/QuestionGroupActor'

interface Props {
  user: User | QuestionGroupActor
}

export default function EmployeeLabel({ user }: Props) {
  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      <UserAvatar size="s40" user={user} />
      <Box overflowX="hidden">
        <Text.Normal weight="medium" ellipsis>
          {user.fullName()}
        </Text.Normal>
      </Box>
    </Box>
  )
}
